import { render, staticRenderFns } from "./product-add.vue?vue&type=template&id=290a2a31&scoped=true&"
import script from "./product-add.vue?vue&type=script&lang=js&"
export * from "./product-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a2a31",
  null
  
)

export default component.exports